import { useCallback, useState } from 'react';

export type ShelfDetailPanelSection = 'predictions' | 'skuList';

export type ShelfDetailPanelSections = Record<ShelfDetailPanelSection, boolean>;

const ALL_CLOSED: ShelfDetailPanelSections = {
  predictions: false,
  skuList: false,
};

const ALL_OPEN: ShelfDetailPanelSections = {
  predictions: true,
  skuList: true,
};

export const usePanelSections = () => {
  const [openSections, setOpenSections] =
    useState<ShelfDetailPanelSections>(ALL_OPEN);

  const setSectionOpen = useCallback(
    (section: ShelfDetailPanelSection, open: boolean) => {
      setOpenSections((current) => ({
        ...current,
        [section]: open,
      }));
    },
    []
  );

  const openAll = useCallback(() => {
    setOpenSections(ALL_OPEN);
  }, []);

  const closeAll = useCallback(() => {
    setOpenSections(ALL_CLOSED);
  }, []);

  return {
    openSections,
    setSectionOpen,
    openAll,
    closeAll,
  };
};
